import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-black py-6 flex justify-center items-center">
      <p className="text-sm text-gray-400 text-center">
        © {year}{" "}
        <span className="text-[#ec4899] font-semibold">Charles Ludig</span>.{" "}
        Tous droits réservés.
      </p>
    </footer>
  );
}
